// src/pages/SendNotification.jsx
import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";

// Usa la misma URL que en Apps Script
const FUNCTION_URL =
  "https://us-central1-cancionesia.cloudfunctions.net/notifySongReady";

export default function SendNotification() {
  const { userId } = useParams();

  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [pin, setPin] = useState("");
  const [sending, setSending] = useState(false);
  const [resultMsg, setResultMsg] = useState("");

    // ✅ Mensajes predefinidos (con ortografía corregida)
  const setMensajeCancionLista = () => {
    setTitulo("Tu canción ya está lista");
    setDescripcion(
      "Si deseas algún ajuste o tienes dudas, comunícate por el chat de la app. Esperamos que la canción sea de tu agrado."
    );
  };

  const setMensajeOferta = () => {
    setTitulo("🔥 Te regalamos créditos.");
    setDescripcion(
      "Te regalamos la misma cantidad de créditos que compres, por tiempo limitado 🎵. Sólo manda mensaje al Chat."
    );
  };


  const canSend =
    !sending &&
    userId &&
    titulo.trim().length > 0 &&
    descripcion.trim().length > 0 &&
    pin === "1234"; // ⬅️ código de seguridad

    const canSendPre =
      !sending &&
      userId &&
      pin === "1234"; // ⬅️ código de seguridad

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSend) return;

    try {
      setSending(true);
      setResultMsg("");

      const resp = await fetch(FUNCTION_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userId,
          titulo: titulo.trim(),
          descripcion: descripcion.trim(),
        }),
      });

      let json = null;
      try {
        json = await resp.json();
      } catch (_) {
        // si no viene JSON, lo dejamos en null
      }

      if (!resp.ok || (json && json.ok === false)) {
        const errText =
          json?.error || json?.raw || `HTTP ${resp.status}`;
        throw new Error(errText);
      }

      setResultMsg(
        `Notificación enviada correctamente.` +
          (json
            ? ` (sent: ${json.sent ?? "?"}, failed: ${json.failed ?? "?"})`
            : "")
      );
    } catch (err) {
      console.error(err);
      setResultMsg("Error al enviar: " + err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <Link to={`/users/${userId}`}>← Volver al usuario</Link>

      <h1 style={{ marginTop: 16 }}>Enviar notificación</h1>
      <p>
        <strong>Usuario ID:</strong> {userId}
      </p>

    <form
        onSubmit={handleSubmit}
        style={{ maxWidth: 600, marginTop: 16 }}
      >
        <div style={{ marginBottom: 12 }}>
          <label>
            Título
            <input
              type="text"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              style={{ width: "100%", padding: 6, marginTop: 4 }}
              placeholder="Ej. Tu canción ya está lista / 🔥 Te regalamos créditos."
            />
          </label>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>
            Texto de la notificación
            <textarea
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              style={{ width: "100%", padding: 6, marginTop: 4, minHeight: 100 }}
              placeholder="Mensaje que verá el usuario en la notificación"
            />
          </label>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label>
            Código de seguridad
            <input
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              style={{ width: "100%", padding: 6, marginTop: 4 }}
              placeholder="Escribe 1234 para habilitar el botón"
            />
          </label>
          <p style={{ fontSize: 12, color: "#777", marginTop: 4 }}>
            Solo si escribes <strong>1234</strong> se activará el botón
            de enviar.
          </p>
        </div>

        <button type="submit" disabled={!canSend}>
          {sending ? "Enviando..." : "Enviar notificación"}
        </button>
      </form>

      {/* ✅ Botones rápidos para autollenar */}
      <div style={{ display: "flex", gap: 10, marginTop: 12, flexWrap: "wrap" }}>
        <button
          type="button"
          disabled={!canSendPre}
          onClick={setMensajeCancionLista}
          style={{ padding: "8px 12px" }}
        >
          Enviar canción lista
        </button>

        <button
          type="button"
          disabled={!canSendPre}
          onClick={setMensajeOferta}
          style={{ padding: "8px 12px" }}
        >
          Enviar oferta
        </button>
      </div>


      {resultMsg && (
        <p style={{ marginTop: 12, fontSize: 14 }}>{resultMsg}</p>
      )}
    </div>
  );
}
